import { Injectable } from '@angular/core';
import { CreatePharmacyLinkDto, CreatePharmacyLinkResponse, InitiatePharmacyLinkDto, InitiatePharmacyLinkResponse, PharmacyLinkDto, PharmacyLinkService } from '../proxy/skybound/sky-gen1/pharmacy-link';
import { ErrorService } from './error.service';
import { Observable } from 'rxjs';
import { ListResultDto } from '@abp/ng.core';
import { LocationDto, LocationService } from '../proxy/skybound/sky-gen1/location';
import { AppConstants } from '../app.constants';
import { environment } from 'src/environments/environment';
import { CacheService } from './cache.service';

@Injectable({
	providedIn: 'root'
})
export class PharmaciesFacadeService
{

	constructor(
		private pharmacyLinkService: PharmacyLinkService,
		private locationService: LocationService,
		private errorService: ErrorService,
		private cacheService: CacheService
	) 
	{

	}

	public getPharmacies(): Observable<ListResultDto<PharmacyLinkDto>>
	{
		return this.pharmacyLinkService.getList({}).pipe();
	}

	public initiatePharmacyLink(birthDate: string, firstNames: string, secondaryAttempt: boolean, organizationId: string): Observable<InitiatePharmacyLinkResponse>
	{
		const input: InitiatePharmacyLinkDto = 
		{
			birthDate,
			organizationId,
			firstNames,
			emailPharmacyOnFailure: secondaryAttempt
		};

		return this.pharmacyLinkService.initiate(input, { });
	}

	public createPharmacyLink(birthDate: string, firstNames: string, organizationId: string, linkCode: string, areTermsAgreed: boolean): Observable<CreatePharmacyLinkResponse>
	{
		const input: CreatePharmacyLinkDto = {
			birthDate,
			firstNames,
			organizationId,
			linkCode,
			areTermsAgreed
		};	

		return this.pharmacyLinkService.create(input, { });
	}

	public getLocationsCached(refreshCache: boolean = false): Observable<ListResultDto<LocationDto>>
	{
		const apiUrl = environment.oAuthConfig?.issuer ?? '-';
		const cacheMilliseconds = 1 * 60 * 60000 * 2; //2 hours
		const cacheKey = `${apiUrl}-locations`;
		if (refreshCache)
		{
			// console.debug(`Refreshing locations cache with key ${cacheKey}`);
			this.cacheService.clear(cacheKey);
		}
		// console.debug(`Getting locations from cache with key ${cacheKey}`);
		return this.cacheService.get(cacheKey, this.getLocations(), cacheMilliseconds);
	}

	private getLocations(): Observable<ListResultDto<LocationDto>>
	{
		const input = {
			filter: '',
			sorting: 'name asc',
			skipCount: 0,
			maxResultCount: 1000,
			onlyOrganizations: true
		}
		return this.locationService.getList(input, {})
	}
}
